import { WinclapLoader } from '@/components/ui/winclap-loader';

export const fmtUSD = (n: number | null | undefined) =>
  n == null ? '—' : `$${Math.round(n).toLocaleString('en-US')}`;

export const fmtUSDCents = (n: number | null | undefined) =>
  n == null ? '—' : `$${n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtNum = (n: number | null | undefined) =>
  n == null ? '—' : Math.round(n).toLocaleString('en-US');

export const fmtPct = (n: number | null | undefined) =>
  n == null ? '—' : `${n.toFixed(1)}%`;

export const fmtMonth = (m: string) => {
  const d = m.length >= 7 ? m.substring(0, 7) : m;
  const [y, mo] = d.split('-');
  return new Date(+y, +mo - 1).toLocaleString('en-US', { month: 'short', year: '2-digit' });
};


export function LoaderBlock() {
  return (
    <div className="flex items-center justify-center py-20">
      <WinclapLoader />
    </div>
  );
}

/** La card de KPI es compartida (components/ui/stat-card); queda re-exportada por los imports viejos. */
export { StatCard } from '@/components/ui/stat-card';
